//https://www.jacklmoore.com/notes/rounding-in-javascript/
export const roundToNDecimalPlaces = (value: number, n: number) =>
  Number(Math.round(Number(value + 'e' + n)) + 'e-' + n);
